
import Vue from "vue";
import axios from "axios";

import Vuex from "vuex";
Vue.use(Vuex);

const state = {
    carts:[],
    db_carts:[],
    client:{}
};
const getters = {
};
const actions = {
    addItem(context, id) {
        context.commit("ADD_Item", id);
    },
    addItemWithQuantity(context, payload) {
        context.commit("ADD_ITEM_WITH_QTY", payload);
    },
    removeItem(context, index) {
        context.commit("REMOVE_Item", index);
    },
    downItem(context, index) {
        context.commit("DOWN_Item", index);
    },
    upItem(context, props) {
        context.commit("UP_Item", props);
    },
    selectClient({commit}, client) {
        commit('setClient', client );
        console.log(client)
    },
};
const mutations = {
    setClient(state, data){
        state.client = data;
    },
    CLEAR_CART(state){
        state.carts = [];
        state.db_carts = [];
    },
    ADD_Item(state, item) {
        state.db_carts.push(item);
        if(state.carts.map(cart=>cart.product).includes(item)){
            const cartItem = state.carts.filter(cart=>cart.product.id == item.id)[0];
            cartItem.quantity = Number(cartItem.quantity || 0) + 1;
        }else{
            state.carts.push({'quantity':1,'product':item});
        }
    },
    ADD_ITEM_WITH_QTY(state, payload) {
        const item = payload?.item;
        const qty = Number(payload?.quantity || 0);
        if (!item || !Number.isFinite(qty) || qty <= 0) {
            return;
        }
        const existing = state.carts.find(cart => cart.product.id == item.id);
        if (existing) {
            existing.quantity = Number(existing.quantity || 0) + qty;
        } else {
            state.carts.push({ quantity: qty, product: item });
        }
    },
    REMOVE_Item(state, index) {
        var id = state.carts[index].id
        state.db_carts.splice(state.db_carts.indexOf(id), 1);
        state.carts.splice(index, 1);
    },
    DOWN_Item(state, index) {
        var id = state.carts[index].id
        state.db_carts.splice(state.db_carts.indexOf(id), 1);

        if((Number(state.carts[index].quantity || 0) - 1) > 0){
            state.carts[index].quantity = Number(state.carts[index].quantity || 0) - 1;
        }else{
            state.carts.splice(index, 1);
        }
    },
    UP_Item(state, props) {
        state.db_carts.push(props.id);
        state.carts[props.index].quantity = Number(state.carts[props.index].quantity || 0) + 1;
    }
};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
